import { RouteObject } from 'react-router-dom';

import { NotificationFlowPaths } from 'routes';
import NotificationScreenWrapper from '../components/notification-screens-wrapper/index';
import { NotificationScreen } from '../screens/notification';
import { NotificationOneFilterListNavigation, NotificationOneFilterList } from '../screens/notification-filter-list';
import NotificationsFilter from '../screens/notification-create-filter-presets';
import NotificationsFilterSecondary from '../screens/notification-create-filter-secondary';

const notificationFlowRouter: RouteObject[] = [
  {
    path: '/',
    element: <NotificationScreenWrapper />,
    children: [
      {
        path: NotificationFlowPaths.main,
        element: <NotificationScreen />,
      },
      {
        path: NotificationFlowPaths.notificationFilterItem,
        element: <NotificationOneFilterList />,
      },
      {
        path: NotificationFlowPaths.notificationFilterItemNavigation,
        element: <NotificationOneFilterListNavigation />,
      },
      {
        path: NotificationFlowPaths.notificationCreateFilter,
        element: <NotificationsFilter />,
      },
      {
        path: NotificationFlowPaths.notificationCreateFilterSecondary,
        element: <NotificationsFilterSecondary />,
      },
    ],
  },
];

export default notificationFlowRouter;
